import {authService} from './auth';
import {API_BASE_URL} from './apiConfig';
// Retained only to migrate results from a pre-registration visitor session.
export function visitorProof(): string | null {return localStorage.getItem('ninaCaptureSession');}
export async function captureHeaders(initial?: HeadersInit, download=false): Promise<Headers> {
  const headers=new Headers(initial);const token=authService.getToken();
  if(!token)throw new Error('Create an account or sign in before using capture.');
  headers.delete('X-Capture-Session');
  headers.set('Authorization',`Bearer ${token}`);
  return headers;
}
export async function captureWallet(): Promise<{available:number;reserved:number}> {
  const response=await fetch(`${API_BASE_URL}/api/capture-session/wallet`,{headers:await captureHeaders(),cache:'no-store'});
  if(!response.ok)throw new Error('Capture balance is temporarily unavailable.');
  return response.json();
}
